import React, { useContext, useEffect } from "react";
import GlobalContext from "contexts/GlobalContext";
import { useHistory, useParams } from "react-router-dom";
import cmsAdapter from "../../common/Adapters/CMSAdapter/CMSAdapter";
import { useState } from "react";
import { SIASearch, useTranslator } from "@sia/style-guide";

const CMSSearch = () => {
  const { language: languageKey, organizationCode } = useContext(GlobalContext);
  const [data, setData] = useState(undefined);
  const { text } = useParams();
  const history = useHistory();
  const translate = useTranslator();
  const setElements = async () => {
    const textAndOrganisationCode = `${text}${organizationCode ? `&organisation=${organizationCode}` : ""}`;
    const response = await cmsAdapter.globalSearch(languageKey, textAndOrganisationCode);
    setData(response);
  }
  useEffect(() => {
    text && languageKey && organizationCode && setElements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, languageKey, organizationCode]);

  useEffect(() => {
    const createBrowserTitle = () => {
      const browserTitle = translate("browser.title");
      if (text) return `${text}  - ${browserTitle}`;
      return browserTitle;
    };
    document.title = createBrowserTitle();
  }, [translate, text]);
  return data !== undefined ? <SIASearch
    lang={languageKey}
    history={history}
    pageItems={data?.filter(el => el.content_type === 'page')}
    articleItems={data?.filter(el => el.content_type === 'sia_article')}
    vacancyItems={data?.filter(el => el.content_type === 'sia_vacancies')}
    employeeItems={data?.filter(el => el.content_type === 'employee')}
    vorstandItems={data?.filter(el => el.content_type === 'vorstand')}
    aliasItems={data?.filter(el => el.content_type === 'alias')}
    downloadsItems={data
      ?.filter(el => el.paragraph_type === 'download_box')
      ?.map(el => ({ ...el, download: el.download[0] }))}
    videoItems={data?.filter(
      el => el.paragraph_type === 'video_box_statische_seite'
    )}
    text={text}
    translate={translate}
  /> : <></>;
};

export default CMSSearch;
